import { useAPIBuktiKaryaListV2 } from 'api/bukti-karya/useAPIBuktiKaryaList'
import { buktiKaryaCategoryMappings } from 'app/KinerjaPage/constants'

import type { BuktiKaryaCategory } from 'types/kinerja'

export default function useBuktiKarya() {
  const buktiKarya = useAPIBuktiKaryaListV2('PDF')

  const isLoading = buktiKarya.isLoading
  const isFetched = buktiKarya.isFetched

  const mappedCategory: BuktiKaryaCategory[] =
    buktiKarya?.data?.data?.karyaCount?.map((category) => ({
      key: category.key,
      total: Number(category.value),
      name:
        buktiKaryaCategoryMappings.find((c) => c.key === category.key)?.title ??
        '',
      iconName:
        buktiKaryaCategoryMappings.find((c) => c.key === category.key)
          ?.iconName ?? '',
    })) ?? []

  const totalAllDocument =
    buktiKarya?.data?.data?.karyaCount
      ?.map((c) => Number(c.value))
      ?.reduce((a, b) => a + b, 0) ?? 0

  return {
    isLoading,
    isFetched,
    categories: mappedCategory,
    total: totalAllDocument,
  }
}
